import React, { useState } from 'react';
import cn from 'classnames';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';
import AddIcon from '@wix/da-ds/pkg/Icons/Add';
import MinusIcon from '@wix/da-ds/pkg/Icons/24x24/Minus';
import type { Faq } from './types';
import DOMPurify from 'isomorphic-dompurify';

import s from './Faqs.scss';

export interface Props {
  faqs: Faq[];
}

const FaqItem: React.FC<{ faq: Faq }> = ({ faq }) => {
  const [isOpen, setIsOpen] = useState(false);
  return (
    <div className={s['wrapper']} key={faq.title}>
      <h3 className={s['question']} onClick={() => setIsOpen(!isOpen)}>
        {faq.title}{' '}
        {isOpen ? <MinusIcon size={IconSize.MEDIUM} /> : <AddIcon size={IconSize.MEDIUM} />}
      </h3>
      <div
        className={cn(s['answer'], isOpen && s['open'])}
        dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(faq.body) }}
      />
    </div>
  );
};

const Faqs: React.FC<Props> = ({ faqs }) => {
  if (!faqs || faqs.length === 0) {
    return null;
  }

  return faqs.map((faq, index) => <FaqItem key={index} faq={faq} />);
};
Faqs.displayName = 'Faqs';

export default Faqs;
